export default __webpack_public_path__ + "92995e618a82373a283d5e0a4b920ab2.png";